import { Base, Component, Inject } from '@/vue-property-decorator'
import { EntryType } from '..'
import { useI18n } from '@/i18n'
import style from './style.module.scss'

/** 兜底背景 注意:有使用absolute定位,因此,父级组件必须要有relative才行. */
@Component<BtnEntry>({
  name: 'BtnEntry'
})
export default class BtnEntry extends Base {
  @Inject('setEntryType')
  private setEntryType!: (entryType: EntryType) => void
  created(): void {
    this.setEntryType(EntryType.Btn)
  }
  render() {
    const { t } = useI18n()
    return (
      <div class={[style['btn-entry'], 'btnEntry']}>
        <span>{t('lobby.game.enterGame')}</span>
      </div>
    )
  }
}
